import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, NgZone, OnInit, signal, ViewChild, ViewEncapsulation } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { GoogleMapsLoaderService } from '../../../../../core/services/google-maps-loader.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { dataUriToBlob } from '../../../../../core/utils/data-uri-util';
import { error } from 'console';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { DefaultConstant } from '../../../../../constants/enum/common/default.enum';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { ImageUploadService } from '../../../../shared/components/form-components/components/profile-upload/image-upload.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { FormActionComponent } from '../../../forms/components/form-action/form-action.component';
import { ShfitFunction } from './start-shift.constant';
import { NgxPermissionsService } from 'ngx-permissions';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';

@Component({
  standalone: false,
  selector: 'kt-start-shift',
  templateUrl: './start-shift.component.html',
  styleUrls: ['./start-shift.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StartShiftComponent extends ModalBaseClass implements OnInit, AfterViewInit {
  location: any = {};
  photo: any = null;
  form: any = null;
  webCamImageUrl = signal<string>('');
  shiftDetails: any = {};
  shiftAllInfo = null;
  timesheet = null;
  distanceFromActualLocation = 0;
  showPhotoStep = true;
  showFillformStep = true;
  formFilled = signal(false);
  isUnScheduled = null;
  user_id = null;
  buttonConfig = BUTTON_CONFIG;
  isLastStep = false;
  functionlity = ShfitFunction.Start;
  shiftFunctionRef = ShfitFunction;
  defaultEnum = DefaultConstant;
  @ViewChild('wizard', { static: true }) el: ElementRef;
  cameraFound = true;
  comment = '';
  cameraAccess = true;
  loading = signal(false);
  mapReady = signal(false);
  infoContent = '';
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  private readonly mapsLoader = inject(GoogleMapsLoaderService);
 permissionForm = this.ngxPermissionService.getPermission(PERMISSIONV2.FORM_MANAGEMENT)
  permissionfaceDetaction = this.ngxPermissionService.getPermission(PERMISSIONV2.FACE_DETECTION)
  private trigger: Subject<void> = new Subject<void>();
  constructor(private imageUploadService: ImageUploadService, private activeModal: NgbActiveModal, private ngbModal: NgbModal , private ngxPermissionService: NgxPermissionsService, private cdr: ChangeDetectorRef, private ngZone: NgZone) {
    super(ngbModal);
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }
  errorHandler(error: WebcamInitError) {
    if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
      console.warn('Camera access was not allowed by user!');
      this.cameraAccess = false;
    }
    // if (event && event.message.toLowerCase() && event.message.toLowerCase().includes('permission denied')) {
    //   this.cameraAccess = false;
    // }
  }

  resetClickHandler() {
    this.webCamImageUrl.set('');
    navigator.permissions.query({ name: 'camera' as PermissionName }).then(res => {
      if (res.state === 'granted') {
        this.cameraAccess = true;
      }
    });
  }
  openInfoWindow(marker: MapMarker, content: string) {
    this.infoContent = content;
    if (this.infoWindow) {
      this.infoWindow.open(marker);
    }
  }

  ngOnInit() {
    this.mapsLoader.load().then(() => this.mapReady.set(true));
    if (navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      navigator.mediaDevices.enumerateDevices().then(devices => {
        if (!devices.some(device => 'videoinput' === device.kind) && this.showPhotoStep) {
          this.webCamImageUrl.set(DefaultConstant.CAMERA_NOT_FOUND);
          this.cameraFound = false;
        }
      });
    }
    if (!this.shiftDetails) {
      this.shiftDetails = {};
    }
    if (this.functionlity === ShfitFunction.End) {
      this.shiftDetails.shiftStartDate = this.timesheet.timesheet_actual_start_date;
    }
   
    if (!this.form || !this.permissionForm) {
      this.showFillformStep = false;
    } 
    if ((this.shiftDetails && this.shiftDetails.location && !this.shiftDetails.location.location_take_photo_at_start_enable && this.functionlity === ShfitFunction.Start) || !this.permissionfaceDetaction) {
      this.showPhotoStep = false;
    }
    if ((this.timesheet && this.timesheet.location && !this.timesheet.location.location_take_photo_at_end_enable && this.functionlity === ShfitFunction.End) || !this.permissionfaceDetaction) {
      this.showPhotoStep = false;
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        // Geolocation callback runs outside Angular's zone in ng21, so wrap it
        // to re-enter the zone and trigger CD — otherwise agm-map stays at (0,0).
        this.ngZone.run(() => {
          this.location.latitude = position.coords.latitude;
          this.location.longitude = position.coords.longitude;
          this.distanceFromActualLocation = CommonUtil.distance(this.location.latitude, this.location.longitude, (+this.shiftAllInfo.area.area_latitude), (+this.shiftAllInfo.area.area_longitude), 'K');
          this.cdr.detectChanges();
        });
      });

    }
     this.cdr.detectChanges();
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      const wizard = new KTWizard(this.el.nativeElement, {
        startStep: 1,
      });
      this.isLastStep  = (this.permissionForm ?  !this.form : true) && (this.permissionfaceDetaction ?  !this.showPhotoStep : true);
      this.cdr.detectChanges();
      wizard.on('beforeNext', (wizardObj) => {
        if (this.showPhotoStep && !this.webCamImageUrl()) {
          wizardObj.stop();

          return;
        }

        if ((wizardObj.currentStep + 1) === wizardObj.totalSteps && this.form && !this.formFilled()) {
          wizardObj.stop();

          return;
        }
        this.isLastStep = ((wizardObj.currentStep + 1) === wizardObj.totalSteps);
        this.cdr.detectChanges();
      });
      wizard.on('beforePrev', (wizardObj) => {
        this.isLastStep = false;
        this.cdr.detectChanges();
      });
    }, 100);
  }


  formFillClickHandler() {
    const componetRef = this.openPopUp(FormActionComponent, { fromInput: true, formData: this.form }, { centered: true, size: 'lg', backdrop: 'static' });
    componetRef.result.then(res => {
      if (res.formFilled) {
        // Signal write auto-schedules CD, so the Fill button flips to Filled
        // even though this resolves in a promise callback.
        this.formFilled.set(true);
      }
    });
  }


  onCamSuccess(webcamImage: WebcamImage) {
    this.uploadbase64Image(webcamImage.imageAsDataUrl);
    // if (this.webCam) {
    //   this.webCam.getBase64().then(base64 => {
    //     this.uploadbase64Image(base64);
    //     this.webCam.ngOnDestroy();
    //   });
    // }
  }

  saveClickHandler() {
    this.activeModal.close({ form: this.form, camera: this.webCamImageUrl(), location: this.location, comment: this.comment });
  }


  uploadbase64Image(base64String: string) {
    this.loading.set(true);
    const formData = new FormData();
    formData.append('file', dataUriToBlob(base64String));
    this.imageUploadService.uploadImage(formData).subscribe(data => {
      this.loading.set(false);
      if (data && data.status === 200) {
        const url = data.data.FileUpload.path;
        this.webCamImageUrl.set(url);
      }
    });
  }

}
